"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformStringToDate = transformStringToDate;
function transformStringToDate(value) {
    if (value && typeof value === "string") {
        return new Date(value);
    }
    return value;
}
//# sourceMappingURL=transformStringToDate.js.map